import { PageHeader } from "@components/page/PageHeader"
import { defineBlock, EditableText, usePostExcerptEditor, usePostTitleEditor } from "eddev/blocks"

export const meta: BlockMeta = {
  title: "Page Header",
  inserter: false,
  icon: "format-aside",
  category: "text",
  flags: {
    fullWidth: true,
  },
  postMetaBlock: {
    fieldName: "pageHeader",
    postTypes: ["page"],
  },
}

export default defineBlock("page/page-header", (props) => {
  return (
    <PageHeader
      mixpanelArea="Page Header"
      breadcrumbs={props.page?.breadcrumbs!}
      title={
        <EditableText
          store={usePostTitleEditor(props.page?.title!)}
          placeholder="Enter a title"
          plainText
          disableLineBreaks
        />
      }
      description={
        <EditableText
          store={usePostExcerptEditor(props.page?.excerpt!)}
          allowedFormats={["core/italic", "core/bold"]}
          placeholder="Add an optional page description"
        />
      }
      theme={props.theme!}
      image={props.headerImage!}
      links={props.links?.map((item) => item?.link!)}
    />
  )
})
